import React from 'react';
import styled from 'styled-components';
import { useIntl } from 'react-intl';

const StyledSquaremark = styled.img`
    width: 70px;
    height: 70px;
`;

export function Squaremark() {
    const { locale } = useIntl();
    const languageCode = locale.split('-')[0];

    return (
        <StyledSquaremark
            alt={__('99designs by Vista')}
            src={`https://assets.99static.com/logos/${languageCode}/squaremark_grey.svg`}
        />
    );
}
